export var BOTPRESS_INTERACTION_ON_MOUNT = 'onMount';
export var BOTPRESS_INTERACTION_CLASSNAME = 'botpress-interaction';
export var BOTPRESS_INTERACTION_TRIGGERS_PREVENT_DEFAULT = ['onSubmit'];